import { render } from "./SiderMenu.vue?vue&type=template&id=63f75310&ts=true"
import script from "./SiderMenu.vue?vue&type=script&lang=ts"
export * from "./SiderMenu.vue?vue&type=script&lang=ts"

import "./SiderMenu.vue?vue&type=style&index=0&id=63f75310&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__